export default "/static/dashboard/build/app/img/v2/91e9799504418b2589730b6d3e55c1ce.png";